/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import serviceHubDetailsQueryParameters from '@jira/servicedesk__customer-service-hub-details/src/__generated__/ServiceHubDetailsPageQuery$parameters.ts';
import type { ServiceHubDetailsPageQuery } from '@jira/servicedesk__customer-service-hub-details/src/__generated__/ServiceHubDetailsPageQuery.graphql.ts';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingDetailsAppEntryPointComponent = EntryPointComponent<
	{
		serviceHubDetailsQuery: ServiceHubDetailsPageQuery;
	},
	{},
	{},
	{} | null
>;

export const helpCenterSettingDetailsAppEntryPoint: EntryPoint<
	HelpCenterSettingDetailsAppEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingDetailsAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-setting-details-app" */ './HelpCenterSettingDetailsApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId, projectKey },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => ({
		queries: {
			serviceHubDetailsQuery: {
				parameters: serviceHubDetailsQueryParameters,
				variables: {
					cloudId,
					helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					projectIdOrKey: projectKey ?? '',
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
